import {
  BasicPortalRoleMultiple,
  ImxUserData,
  RolesInfo,
  SelectedRoleInfo,
  UserRole
} from '../../../../store/roles/types';

/**
 * Filters
 */
export const mapApiUserRoleFromSelectedRoleInfo = (
  selectedRoleInfo: SelectedRoleInfo[],
  permissions: BasicPortalRoleMultiple[],
  imxData: ImxUserData
): UserRole[] =>
  permissions
    // Not nullable??
    // .filter((x) => x.roleName)
    .flatMap((permission) => {
      return permission.roleData.map<UserRole>((roleData) => {
        const industryFiltered = selectedRoleInfo.filter(
          (roleInfo) =>
            roleInfo.industryCode === permission.industry.industryCode
        );
        const filterByDefined = (strArr: (string | undefined)[]) =>
          strArr.filter((str) => str) as string[];

        return {
          industryText: permission.portal || '',
          industryOrder: permission.industry.industryOrder || 0,
          industry: permission.industry.industryCode,
          countries: filterByDefined(
            industryFiltered.map((roleInfo) => roleInfo.siteCountryDescription)
          ),
          companies: filterByDefined(
            industryFiltered.map((roleInfo) => roleInfo.companyId)
          ),
          plantUnits: filterByDefined(
            industryFiltered.map((roleInfo) => roleInfo.plantUnitId)
          ),
          roleName: roleData.roleName,
          rolePriority: roleData.rolePriority,
          roleDisplayName: roleData.roleDisplayName,
          portal: permission.portal,
          imxUserData:
            permission.industry.industryCode === 3 ? imxData : undefined,
        };
      });
    });

/**
 * Finders
 */
export const getIndustryFromCountryCode = (
  rolesInfo: RolesInfo = [],
  siteCountryCode: string = ''
): number =>
  rolesInfo?.find((industry) =>
    industry.countries.some(
      (country) => country.siteCountryCode === siteCountryCode
    )
  )?.industryCode as number;

/**
 * Comparators
 */
export const isSelectedRoleInfoEqual = (
  selectedRoleInfo1: SelectedRoleInfo,
  selectedRoleInfo2: SelectedRoleInfo
): boolean =>
  selectedRoleInfo1.industryCode === selectedRoleInfo2.industryCode &&
  selectedRoleInfo1.siteCountryCode === selectedRoleInfo2.siteCountryCode &&
  selectedRoleInfo1.companyId === selectedRoleInfo2.companyId &&
  selectedRoleInfo1.plantUnitId === selectedRoleInfo2.plantUnitId;
